import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class HelpCenter extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    };
    
    render() {
        return (
            <div className="HelpCenter">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" 
                    onClick={() => this.props.history.goBack()}></i>
                }
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="content" onClick={() => this.props.history.push('/aboutMintu')}>
                        <div className="floatL">关于预约出行服务</div>
                        <div className="icon iconfont icontiaozhuan"></div>
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/ridingKnow')}>
                        <div className="floatL">乘车须知</div>
                        <div className="icon iconfont icontiaozhuan"></div>
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/ticketRefund')}>
                        <div className="floatL">退票收费标准</div>
                        <div className="icon iconfont icontiaozhuan"></div>
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/invoiceApply')}>
                        <div className="floatL">关于发票申请</div>
                        <div className="icon iconfont icontiaozhuan"></div>
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/linePrice')}>
                        <div className="floatL">关于起止区域价格</div>
                        <div className="icon iconfont icontiaozhuan"></div>
                    </div>
                    <div className="content" onClick={() => this.props.history.push('/realName')}>
                        <div className="floatL">关于实名乘车的说明</div>
                        <div className="icon iconfont icontiaozhuan"></div>
                    </div>
                </div>
            </div>
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/HelpCenter/index.js